module.exports = __webpack_public_path__ + "media/images/flags/fr-d7acb86a0942ed56ea92a624f187152d.svg";